import _ from 'lodash';
import React from 'react';

import {OCCUPANCY_TYPE_CHOICES} from 'ducks/occupancy';

import ButtonSwitch from 'components/ButtonSwitch';

import './styles.css';

const selectViewOptions = [
  {label: 'Revenue Occupancy', value: OCCUPANCY_TYPE_CHOICES.REVENUE_OCCUPANCY},
  {
    label: 'Physical Occupancy',
    value: OCCUPANCY_TYPE_CHOICES.PHYSICAL_OCCUPANCY
  }
];

const PhysicalSwitchSection = props => {
  const {activeTab, onChange} = props;
  return (
    <ButtonSwitch
      className="PhysicalSwitchSection__occupancyTypeSwitch"
      options={selectViewOptions}
      initialValue={activeTab}
      onChange={activeTab => onChange(activeTab.value)}
    />
  );
};

export default PhysicalSwitchSection;
